import { render, staticRenderFns } from "./PettyCash.vue?vue&type=template&id=c6e2d580"
import script from "./PettyCash.vue?vue&type=script&lang=js"
export * from "./PettyCash.vue?vue&type=script&lang=js"
import style0 from "./PettyCash.vue?vue&type=style&index=0&id=c6e2d580&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports